import CustomButton from "Components/Custom/CustomButton";
import CustomInput from "Components/Custom/CustomInput";
import { FormikProps } from "formik";
import { PaymentValues } from "pages/Settings/Cards/PaymentsAndInvoicing";
import { Col, Row } from "reactstrap";

interface PaymentInfoProps {
  validation: FormikProps<PaymentValues>;
  loading?: boolean;
}

const PaymentInfo = ({ validation, loading }: PaymentInfoProps) => {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        validation.handleSubmit();
      }}
      action="#"
    >
      <Row>
        <Col md="12" className="mt-4 pt-2">
          <h2 className="text-black2D fs-14 fw-medium font-primary mb-4">
            PAYMENT LINK
          </h2>

          <Col md="12" className="mb-1">
            <CustomInput
              label="PayPal, Stripe, or other"
              placeholder="Enter id"
              type="text"
              name="paymentId"
              value={validation.values.paymentId}
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              touched={validation.touched.paymentId}
              error={validation.errors.paymentId}
            />
          </Col>
          <Col md="12">
            <div className="divider" />
          </Col>

          <h2 className="text-black2D fs-14 fw-medium font-primary mb-4 pt-2">
            BANK INFO
          </h2>
          <Row className="mb-1">
            <Col md="6">
              <CustomInput
                label="Bank Name"
                placeholder="Enter bank name"
                type="text"
                name="bankName"
                value={validation.values.bankName}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                touched={validation.touched.bankName}
                error={validation.errors.bankName}
              />
            </Col>

            <Col md="6">
              <CustomInput
                label="Account Name"
                placeholder="Enter account "
                name="accountName"
                type="text"
                value={validation.values.accountName}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                touched={validation.touched.accountName}
                error={validation.errors.accountName}
              />
            </Col>
          </Row>
          <Row className="mb-1">
            <Col md="6">
              <CustomInput
                label="Account Number"
                placeholder="Enter account number"
                type="text"
                name="accountNumber"
                value={validation.values.accountNumber}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                touched={validation.touched.accountNumber}
                error={validation.errors.accountNumber}
              />
            </Col>

            <Col md="6">
              <CustomInput
                label="Sort Code"
                placeholder="Enter sort code"
                name="sortCode"
                type="string"
                value={validation.values.sortCode}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                touched={validation.touched.sortCode}
                error={validation.errors.sortCode}
              />
            </Col>
          </Row>

          <Col md="12" className="mt-4">
            <CustomButton
              text="Save Changes"
              type="submit"
              className="bg-primary br-7 "
              loading={loading}
            />
          </Col>
        </Col>
      </Row>
    </form>
  );
};

export default PaymentInfo;
